<template>
  <main v-if="starterOverLay" class="md:px-44">
    <overlay :transparentBg="false" />
    <!-- <SpeechReader :text="myContent" zIndexProps="z-30"/> -->
    <section class="top-56 z-20 fixed transform -translate-x-1/2 -translate-y-1/2 left-1/2">
      <article class="grid gap-4 justify-center">
          <div class="grid justify-center">
            <img src="../assets/gPay-merchant-icon.png" alt="" class="h-46">
          </div>
          <p class="font-myriad text-center font-bold text-xl pb-4">Return to GPay Business</p>
          <div class="w-80 justify-self-center grid gap-2 text-center">
            <p class="label-text-myriad-primary">Please go back to GPay and continue your </p>
            <p class="flex gap-1 justify-center">ePaylater loan process.</p>
            <p class="label-text-myriad-primary">कृपया GPay पर वापस जाएं और अपनी ePaylater लोन प्रक्रिया जारी रखें।</p>
          </div>
      </article>
    </section>
    <span class="grid pb-40"></span>
      <section class="footer mb-2 justify-center">
        <div class="gap-2 grid justify-center text-center">
          <p class="label-text-headingColor-myriad">Trusted Credit Partner</p>
          <img src="../assets/logo-primary.svg" alt="" class="w-24 justify-self-center"/>
        </div>
        <!-- <p
          @click="$emit('on-click-back-prev')"
          class="label-text-myriad-primary text-sm text-primary underline cursor-pointer"
        >
          Back to previous page
        </p> -->
      </section>
  </main>
</template>
<script>
import { mapGetters } from 'vuex';
import Overlay from './Overlay.vue';
// import SpeechReader from "./SpeechReader.vue";

export default {
  name: 'overLay Go Back',
  components: {
    Overlay,
    // SpeechReader
  },
  mounted() {
    this.init();
  },
  computed: {
    ...mapGetters([]),
  },
  props: {
    starterOverLay: {
      type: Boolean,
      required: false,
      default: false,
    },
    isNoOneMoney: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      myContent: `
        This page opened in your browser to complete a step for your ePayLater loan; please minimize or close the browser and return to the GPay Business app to continue the remaining process.
        यह पेज आपके ePayLater लोन की एक प्रक्रिया पूरी करने के लिए ब्राउज़र में खुला है; कृपया ब्राउज़र को मिनिमाइज़ या बंद करें और बाकी प्रक्रिया जारी रखने के लिए GPay Business ऐप पर वापस जाएँ।
        Thank you, ePayLater.
      `,
    };
  },
  methods: {
    init() {
      this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_THIRD_PARTY_TAB_SWITCH);
    },
  }
};
</script>
<style lang="scss" scoped>
</style>
